import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { elementsActions } from '../actions/elements.actions';
import { selectElements, selectLoaded, selectLoading, selectLookup, selectLookupLoaded, selectTotal } from '../selectors/elements.selector';

@Service()
export class ElementsFacade {
    private readonly store = inject(Store);

    readonly elements = this.store.selectSignal(selectElements);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly total = this.store.selectSignal(selectTotal);
    readonly lookupLoaded = this.store.selectSignal(selectLookupLoaded);
    readonly lookup = this.store.selectSignal(selectLookup);

    getElements(page: number, limit: number): void {
        this.store.dispatch(elementsActions.getElements({ value: { page, limit } }));
    }

    getElementsLookup(): void {
        this.store.dispatch(elementsActions.getElementsLookup());
    }

    clear(): void {
        this.store.dispatch(elementsActions.clear());
    }
}
